import axios from 'axios'
import Cookies from 'js-cookie'
import setLocalStorage  from '../utils/setLocalStorage.js'

 //刷新请求token
export function axiosTimer(refreshToken){
    let isLoad=false 
	let nowTimer=new Date().getTime()
    let cookTimer = window.localStorage.getItem("cookieTimer")||0;
    let msec = nowTimer - cookTimer;  
    // 计算时分秒数  
    let min = parseInt(msec / 1000 / 60 % 60) ; 
	if(min>=20&&min<30){
		console.log('====重新请求======')
		window.localStorage.setItem("cookieTimer",nowTimer);
        if(isLoad) return
        isLoad = true;
        axios.get(`/refreshToken?refreshToken=${refreshToken}`).then(res=>{ 
            let data = res.data;
            // console.log(res)
            if (data && data.code == 0) {
                setLocalStorage(data)
                // window.localStorage.setItem("token", data.access_token);
				// window.localStorage.setItem("token_type", data.token_type);
				// window.localStorage.setItem("refresh_token", data.refresh_token);
				// window.localStorage.setItem("expir", data.expires_in); 
                // window.localStorage.setItem("cookieTimer", new Date().getTime()||"");
                // //保持和修改登录之前数据一样 
                // Cookies.set("token", data.access_token)
            }else{ 
                console.log(res.msg||'刷新token失败～')
            }
            isLoad = false;
        })
	} 
	let sec = parseInt(msec / 1000 % 60) 
    // 控制台打印 
    console.log( `${min}分钟  `,msec,sec) 
} 